module.exports = __webpack_public_path__ + "static/media/instagram-filled.e56003e7.svg";